import * as config from '@/config'
import * as types from '@/stores/mutation-types'

import axios from 'axios'
import VueAxios from 'vue-axios'

window.axios = axios

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'Authorization': `Bearer ${localStorage.getItem('token')}`
}

// userId: { id: "", provider: "email/facebook/google", }
// userInfo: { email: "", }
// action: function()
const state = {
	isAuthenticated: false,
	user: null,
	action: null,
	isInitted: false
}

const getters = {
	isAuthenticated: state => state.isAuthenticated,
	isInitted: state => state.isInitted,
	user: state => state.user,
}

const actions = {
	openLoginModal({ commit }) {
		commit(types.SET_MODAL_NAME, 'auth', { root: true })
		commit(types.SET_ROUTER_NAME, 'login', { root: true })
		commit(types.SET_ROUTER_PARAM, null, { root: true })
	},
	openRegisterModal({ commit }) {
		commit(types.SET_MODAL_NAME, 'auth', { root: true })
		commit(types.SET_ROUTER_NAME, 'register', { root: true })
		commit(types.SET_ROUTER_PARAM, null, { root: true })
	},
	openForgotPasswordModal({ commit }) {
		commit(types.SET_MODAL_NAME, 'auth', { root: true })
		commit(types.SET_ROUTER_NAME, 'forgot', { root: true })
		commit(types.SET_ROUTER_PARAM, null, { root: true })
	},
	closeAuthModal({ commit }) {
		commit(types.SET_ROUTER_NAME, 'close', { root: true })
		commit(types.SET_ROUTER_PARAM, null, { root: true })
	},
	loadFacebookSDK() {
		//Loading Facebook SDK
		window.fbAsyncInit = function() {
			FB.init({
				appId      : config.FACEBOOK_APP_ID,
				xfbml      : true,
				version    : 'v2.10'
			})
			FB.AppEvents.logPageView()
		};
		(function(d, s, id){
			var js, fjs = d.getElementsByTagName(s)[0]
			if (d.getElementById(id)) {return}
			js = d.createElement(s)
			js.id = id
			js.src = "//connect.facebook.net/en_US/sdk.js"
			fjs.parentNode.insertBefore(js, fjs)
		}(document, 'script', 'facebook-jssdk'))
	},
	loadGoogleSDK() {
		//Loading Google Identity SDK
		(function(d, s, id){
			var js, fjs = d.getElementsByTagName(s)[0]
			if (d.getElementById(id)) {return}
			js = d.createElement(s)
			js.id = id
			js.src = "//apis.google.com/js/platform.js"
			fjs.parentNode.insertBefore(js, fjs)
		}(document, 'script', 'google-jssdk'))
	},
	loginViaEmail({ commit, dispatch }, userData) {
		axios.post(`${config.BASE_URL}/login`, {
			usernameOrEmail: userData.usernameOrEmail,
			password: userData.password,
		})
		.then( (response) => {
			if(response.data.code > 0) {
				commit(types.SET_ERROR_MSG, response.data.message, { root: true })
			} else {
				dispatch('LoginSuccess', response.data.data)
			}
		})
		.catch( (error) => {
			commit(types.SET_ERROR_MSG, error, { root: true })
		})
	},
	loginViaGoogle({ commit, dispatch }) {
		gapi.load('auth2', function(){
			const auth2 = gapi.auth2.init({
				client_id: config.GOOGLE_CLIENT_ID,
				cookiepolicy: config.GOOGLE_COOKIE_POLICY,
				scope: config.GOOGLE_SCOPE
			})
			console.log(auth2)

			auth2.signIn().then((response) => {
				let userID = {
					id: response.getBasicProfile().getId(),
					provider: 'google'
				}

				commit(types.SET_USER_ID, userID)

				axios.post(`${config.BASE_URL}/auth/googleplus/login`, {
					googlePlusAccessToken: response.getAuthResponse(true).access_token
				})
				.then( (response) => {
					if(response.data.code > 0) {
						commit(types.SET_ERROR_MSG, response.data.message, { root: true })
					} else {
						dispatch('LoginSuccess', response.data.data)
					}
				})
				.catch( (error) => {
					commit(types.SET_ERROR_MSG, error, { root: true })
				})
			})
		})
	},
	loginViaFacebook({ commit, dispatch }) {
		FB.login(function(response) {
			if (response.status === 'connected') {
				let userID = {
					id: response.authResponse.userID,
					provider: 'facebook'
				}
				commit(types.SET_USER_ID, userID)

				axios.post(`${config.BASE_URL}/auth/facebook/login`, {
					facebookId: userID.id,
					facebookAccessToken: response.authResponse.accessToken,
				})
				.then( (response) => {
					if(response.data.code > 0) {
						commit(types.SET_ERROR_MSG, response.data.message, { root: true })
					} else {
						dispatch('LoginSuccess', response.data.data)
					}
				})
				.catch( (error) => {
					commit(types.SET_ERROR_MSG, error, { root: true })
				})
			}
			else {
				console.log('fail')
			}
		},{scope: config.FACEBOOK_SCOPE})
	},
	getUserInfoViaFacebook({ commit }, userId){
		FB.api(
			`/${userId}`,
			function (response) {
				if (response && !response.error) {
					commit(types.SET_USER_INFO, response)
				}
			}
		)
	},
	checkAuth({ state, commit, dispatch }, action) {
		if(state.isAuthenticated){
			action()
		}
		else{
			commit(types.ADD_ACTION, action)
			dispatch('openLoginModal')
		}
	},
	setLocalToken({ commit, dispatch }, token) {
		localStorage.setItem('token', token)
		window.axios.defaults.headers.common = {
			'Authorization': `Bearer ${localStorage.getItem('token')}`
		};
	},
	LoginSuccess({ state, commit, dispatch }, data) {
		dispatch('setLocalToken', data.token)
		dispatch('closeAuthModal')
		commit(types.SET_USER, data.user)
		commit(types.LOGIN_SUCCESS)
		if(state.action != null){
			state.action()
			commit(types.DEL_ACTION)
		}

		var QueryString = function () {
			var query_string = {};
			var query = window.location.search.substring(1);
			var vars = query.split("&");
			for (var i=0;i<vars.length;i++) {
				var pair = vars[i].split("=");
				// If first entry with this name
				if (typeof query_string[pair[0]] === "undefined") {
					query_string[pair[0]] = decodeURIComponent(pair[1]);
				// If second entry with this name
				} else if (typeof query_string[pair[0]] === "string") {
					var arr = [ query_string[pair[0]],decodeURIComponent(pair[1]) ];
					query_string[pair[0]] = arr;
				// If third or later entry with this name
				} else {
					query_string[pair[0]].push(decodeURIComponent(pair[1]));
				}
			}
			return query_string;
		}();
		if (QueryString.redirect){
			window.location.href = (`${config.PUBLIC_PATH}${QueryString.redirect}`).replace('//', '/')
		}
	},
	forgotPasswordSent({ commit }, data) {
		commit(types.SET_MODAL_NAME, 'auth', { root: true })
		commit(types.SET_ROUTER_NAME, 'forgotSent', { root: true })
		commit(types.SET_ROUTER_PARAM, data.email)
	},
	initAuthUser({ state, commit, dispatch }) {
		let token = localStorage.getItem('token')
		if(token) {
			window.axios.get(`${config.BASE_URL}/user/info`)
			.then( (response) => {
				if(response.data.code === 0) {
					commit(types.SET_USER, response.data.data.user)
					commit(types.LOGIN_SUCCESS)
					// if (response.data.data.user.roleLevel < 99) {
					// 	window.localStorage.clear()
					// 	// window.location.reload()
					// 	window.location.href = `${config.PUBLIC_PATH}login`
					// } else {
					// 	commit(types.SET_USER, response.data.data.user)
					// 	commit(types.LOGIN_SUCCESS)
					// }
				} else {
					window.localStorage.clear()
					window.location.reload()
				}
				commit(types.SET_INITIAL_STATE, true)
			})
			.catch((e) => {
				window.localStorage.clear()
				window.location.reload()
			})
		} else {
			commit(types.SET_INITIAL_STATE, true)
		}
	}
}

const mutations = {
	[types.LOGIN_SUCCESS] (state) {
		state.isAuthenticated = true
	},
	[types.ADD_ACTION] (state, action) {
		state.action = action
	},
	[types.DEL_ACTION] (state) {
		state.action = null
	},
	[types.SET_USER] (state, user) {
		state.user = user
	},
	[types.SET_USER_ID] (state, userId) {
		state.userId = userId
	},
	[types.SET_USER_INFO] (state, userInfo) {
		state.userInfo = userInfo
	},
	[types.SET_INITIAL_STATE] (state, status) {
		state.isInitted = status
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
